module.exports = __webpack_public_path__ + "img/honor.8997fdb2.webp";